// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as Setting from "../conf/Setting";

export function getApplications(owner, page = "", pageSize = "", field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-applications?owner=${owner}&p=${page}&pageSize=${pageSize}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getApplicationsByOrganization(owner, organization) {
  return fetch(`${Setting.ServerUrl}/api/get-organization-applications?owner=${owner}&organization=${organization}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getApplication(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-application?uid=${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getApplicationById(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-application?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getUserApplication(owner, userName) {
  return fetch(`${Setting.ServerUrl}/api/get-user-application?id=${owner}/${encodeURIComponent(userName)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getApplicationByClientId(clientId, clientSecret) {
  return fetch(`${Setting.ServerUrl}/api/get-application-by-clientId?client_id=${clientId}&client_secret=${clientSecret}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function updateApplication(owner, uid, application) {
  const newApplication = Setting.deepCopy(application);
  return fetch(`${Setting.ServerUrl}/api/update-application?id=${owner}/${encodeURIComponent(uid)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newApplication),
  }).then(res => res.json());
}

export function addApplication(application) {
  const newApplication = Setting.deepCopy(application);
  return fetch(`${Setting.ServerUrl}/api/add-application`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newApplication),
  }).then(res => res.json());
}

export function deleteApplication(application) {
  const newApplication = Setting.deepCopy(application);
  return fetch(`${Setting.ServerUrl}/api/delete-application`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newApplication),
  }).then(res => res.json());
}

export function getSamlMetadata(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/saml/metadata?application=${owner}/${encodeURIComponent(uid)}`, {
    method: "GET",
    credentials: "include",
    responseType: "blob",
  }).then(res => res.text());
}

// 获取用户可以访问的应用列表
export function getUserApps(owner, userid) {
  return fetch(`${Setting.ServerUrl}/api/get-user-apps?id=${owner}/${encodeURIComponent(userid)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

// 获取用户可以访问的应用列表，用于统一门户
export function getUserAppDetails(owner, userid, keyword = "") {
  return fetch(`${Setting.ServerUrl}/api/get-user-app-details?id=${owner}/${encodeURIComponent(userid)}&keyword=${keyword}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}
